import { Progress } from "@/ui/components/ui/progress";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const MachineCardSkeleton = () => {
  const { t } = useTranslation("machines");

  return (
    <div className="p-4 flex flex-col bg-sidebar rounded-2xl border-t-4 gap-4 duration-300" style={{
      borderColor: "#6b7280"
    }}>
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin text-primary" />
          <span className="text-muted-foreground">{t("card.loading")}</span>
        </div>
        <div className="w-4 h-4 bg-gray-300 rounded-full"></div>
      </div>
      
      <div className="space-y-2">
        <div className="flex justify-between items-center gap-4 text-xs">
          <span>{t("card.lastSeenLabel")}</span>
          <span className="text-muted-foreground">--</span>
        </div>
        <div className="flex justify-between items-center gap-4 text-xs">
          <span>{t("card.deviceIdLabel")}</span>
          <span className="text-muted-foreground">--</span>
        </div>
      </div>
      
      <div className="mt-auto">
        <Progress value={35} className="h-1 mb-2" />
        <div className="flex gap-2">
          <div className="flex-1 h-8 bg-gray-200 rounded-lg animate-pulse"></div>
          <div className="flex-1 h-8 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default MachineCardSkeleton;
